import { generateIdFromEntropySize } from "@lib/utils/generateKey";
import { authGlobalApiClient } from "@api-client/auth_global";
import { getEnvVariable } from "@lib/utils/getEnvVariable";
import { toast } from "@/ui-plus/sonner";
import { authApiClient } from "@api-client/auth";
import { setAuthState, emptyState } from "@api-client/auth/auth";
import { sha256Hash } from "@lib/clientUtils/sha256Hash";
import { CODE_VERIFIER_KEY, STATE_KEY } from "@api-client/auth/auth.consts";

export const initiateRedirectUserSettings = async (isAfterLogout: boolean = false) => {
    const url = new URL(`https://${getEnvVariable('PUBLIC_ID_AUTH_DOMAIN')}/`);
    url.searchParams.set('next', window.location.href);
    url.searchParams.set('type', 'settings');
    if (isAfterLogout === true) {
        url.searchParams.set('is_after_logout', 'true');
    }
    window.top!.location.href = url.toString();
}

/**
 * Initiate PKCE login - generates verifier and redirects to auth frontend
 */
export async function initiateRedirectLogin(
    // auth: 'login' | 'signup' | 'otp' = 'login',
    type: 'ask' | 'settings' = 'ask',
): Promise<void> {
    const codeVerifier = generateIdFromEntropySize(64);
    localStorage.setItem(CODE_VERIFIER_KEY, codeVerifier);
    const state = generateIdFromEntropySize(32);
    localStorage.setItem(STATE_KEY, state);
    const url = new URL(`https://${getEnvVariable('PUBLIC_ID_AUTH_DOMAIN')}/`);
    url.searchParams.set('next', window.location.href);
    url.searchParams.set('type', type); // | 'settings'
    // url.searchParams.set('auth', auth); // | 'signup' | 'otp'
    url.searchParams.set('pkce_code_challenge', await sha256Hash(codeVerifier));
    url.searchParams.set('pkce_state', state);
    window.location.href = url.toString();
}

export const logout = async () => {
    const { error } = await (await authGlobalApiClient['logout-single'].$post()).json();
    if (!error) {
        await setAuthState(emptyState);
        initiateRedirectUserSettings(true);
    }
}

// export const createNativeSession = async () => {
//     const { data, error } = await (await authGlobalApiClient.create_native_session.$post()).json();
//     if (!error) {
//         console.log('createNativeSession', data);
//     } else {
//         console.error('createNativeSession', error);
//     }
//     return { data, error };
// }


export const exchange = async (values: { code: string, code_verifier: string, state: string }) => {
    const { data, error } = await (await authApiClient.pkce.exchange.$post({
        form: values,
    })).json();
    if (!error) {
        await setAuthState(data);
    }
    return { data, error };
}

export const pkceCheckAuthParams = async () => {
    const urlParams = new URLSearchParams(window.location.hash.slice(1));
    const zmgCode = urlParams.get('zmg_code');
    const zmgState = urlParams.get('zmg_state');

    // If we have auth code and it was shared from parent, exchange it
    if (zmgCode && zmgState) {
        const storedCodeVerifier = localStorage.getItem(CODE_VERIFIER_KEY);
        const storedState = localStorage.getItem(STATE_KEY);

        // Verify state matches
        if (storedState !== zmgState) {
            await logout();
            return;
        }

        if (!storedCodeVerifier) {
            // alert('Unexpected error: stored Code verifier not available');
            toast.error('Unexpected error: stored Code verifier not available');
            return;
        }


        const { error } = await exchange({
            code: zmgCode,
            code_verifier: storedCodeVerifier,
            state: zmgState,
        });

        // Clean up stored values
        localStorage.removeItem(CODE_VERIFIER_KEY);
        localStorage.removeItem(STATE_KEY);
        // remove url hash params
        const urlHashParams = new URLSearchParams(window.location.hash.slice(1));
        urlHashParams.delete('zmg_code');
        urlHashParams.delete('zmg_state');
        urlHashParams.delete('zmg_shared_auth_code_flow');

        const remainingHash = urlHashParams.toString();
        window.history.replaceState({}, '', remainingHash ? `#${remainingHash}` : window.location.pathname);

        if (error) {
            console.error('authentication failed', error);
            console.error(error.message);
            alert('authentication failed');
            toast.error('authentication failed');
        }
    }
}